export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13294.47e48dfc.jpg";